__turbopack_context__.v({
  "cardBottomRow": "BlueprintCards-module__Ts-M1a__cardBottomRow",
  "cardImage": "BlueprintCards-module__Ts-M1a__cardImage",
  "cardPrice": "BlueprintCards-module__Ts-M1a__cardPrice",
  "cardPriceDiscounted": "BlueprintCards-module__Ts-M1a__cardPriceDiscounted",
  "cards": "BlueprintCards-module__Ts-M1a__cards",
  "cardsContainer": "BlueprintCards-module__Ts-M1a__cardsContainer",
  "contentArea": "BlueprintCards-module__Ts-M1a__contentArea",
  "descriptionText": "BlueprintCards-module__Ts-M1a__descriptionText",
  "details": "BlueprintCards-module__Ts-M1a__details",
  "discountBadge": "BlueprintCards-module__Ts-M1a__discountBadge",
  "error": "BlueprintCards-module__Ts-M1a__error",
  "icon": "BlueprintCards-module__Ts-M1a__icon",
  "imageButtonSlot": "BlueprintCards-module__Ts-M1a__imageButtonSlot",
  "loyaltyBadges": "BlueprintCards-module__Ts-M1a__loyaltyBadges",
  "main": "BlueprintCards-module__Ts-M1a__main",
  "nightsText": "BlueprintCards-module__Ts-M1a__nightsText",
  "noTrips": "BlueprintCards-module__Ts-M1a__noTrips",
  "noTripsArrow": "BlueprintCards-module__Ts-M1a__noTripsArrow",
  "noTripsBlock": "BlueprintCards-module__Ts-M1a__noTripsBlock",
  "noTripsBlockContent": "BlueprintCards-module__Ts-M1a__noTripsBlockContent",
  "noTripsBlockDescription": "BlueprintCards-module__Ts-M1a__noTripsBlockDescription",
  "noTripsBlockText": "BlueprintCards-module__Ts-M1a__noTripsBlockText",
  "noTripsIconCircle": "BlueprintCards-module__Ts-M1a__noTripsIconCircle",
  "originalPrice": "BlueprintCards-module__Ts-M1a__originalPrice",
  "overview": "BlueprintCards-module__Ts-M1a__overview",
  "overviewText": "BlueprintCards-module__Ts-M1a__overviewText",
  "priceFrom": "BlueprintCards-module__Ts-M1a__priceFrom",
  "priceNights": "BlueprintCards-module__Ts-M1a__priceNights",
  "priceTrigger": "BlueprintCards-module__Ts-M1a__priceTrigger",
  "tierBadge": "BlueprintCards-module__Ts-M1a__tierBadge",
  "triggerArea": "BlueprintCards-module__Ts-M1a__triggerArea",
});
